import React, { useState, useRef } from 'react';

import classes from "./LeadingControl.css";
import List from "./List/List";
import ListItem from "./ListItem/ListItem";
import SubList from "./SubList/SubList";


import { IconButton, Button, Divider, FormControlLabel, Switch } from "@material-ui/core";
import {
    VideoCall, Apps, Notifications,
    MoreVert, AccountCircle, PlayCircleOutline, CastRounded,
    MusicVideo, Games, School, Category, Message, Brightness2, LanguageOutlined, Settings, SecurityOutlined, HelpOutline, Feedback, FeedbackOutlined, Keyboard
} from "@material-ui/icons";

const LeadingControl = (props) => {
    let customStyle = {};
    if (props.style) {
        customStyle = props.style;
    }

    let [openVideo, setOpenVideo] = useState(false);
    let [openApps, setOpenApps] = useState(false);
    let [openNotify, setOpenNotify] = useState(false);
    let [openMenu, setOpenMenu] = useState(false);

    let [toggleTheme, setToggleTheme] = useState(true);

    let allSets = [setOpenVideo, setOpenApps, setOpenNotify, setOpenMenu]

    function toggle(set) {
        allSets.filter(s => s !== set).forEach(other => other(_ => false));
        set(prev => !prev);

    }

    return (
        <div className={classes.LeadingControl} style={{ ...customStyle }}>
            <div className={classes.wrapContent} >
                <IconButton onClick={() => { toggle(setOpenVideo) }} className={classes.iconButton}>
                    <VideoCall />

                </IconButton>
                {openVideo ?
                    <div className={classes.DropDownMenu}>
                        <List size="small">
                            <ListItem text="Upload video" icon={PlayCircleOutline} color="red" />
                            <ListItem text="Go live" icon={CastRounded} color="red" />
                        </List>
                    </div> : null
                }
            </div>
            <div className={classes.wrapContent} >
                <IconButton onClick={() => { toggle(setOpenApps) }} className={classes.iconButton}>
                    <Apps />

                </IconButton>
                {openApps ?
                    <div className={classes.DropDownMenu}>
                        <List size="medium">
                            <ListItem text="Youtube TV" icon={PlayCircleOutline} color="red" />
                            <Divider className={classes.divider} />
                            <ListItem text="Youtube Music" icon={MusicVideo} color="red" />
                            <ListItem text="Youtube Kids" icon={Games} color="red" />
                            <Divider className={classes.divider} />
                            <ListItem text="Creator Academy" icon={School} color="red" />
                            <ListItem text="Youtube For Artists" icon={Category} color="red" />
                        </List>
                    </div> : null
                }
            </div>
            <div className={classes.wrapContent} >

                <IconButton onClick={() => { toggle(setOpenNotify) }} className={classes.iconButton}>
                    <Notifications />

                </IconButton>
                {openNotify ?
                    <div className={classes.DropDownMenu}>
                        <List size="large" header="Messages" >
                            <ListItem text="message 1" icon={Message} color="grey" />
                        </List>
                    </div> : null
                }
            </div>
            <div className={classes.wrapContent} >
                <IconButton onClick={() => { toggle(setOpenMenu) }} className={classes.iconButton}>
                    <MoreVert />

                </IconButton>
                {openMenu ?

                    <div className={classes.DropDownMenu}>
                        <List size="large" >

                            <SubList text="Dark theme: on" icon={Brightness2} color="grey">
                                <ListItem text="on/off" >
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={toggleTheme}
                                                onChange={() => { setToggleTheme(prev => !prev) }}
                                                value="checkedB"
                                                classes={{
                                                    thumb: classes.switch,
                                                    checked: classes.switchCheck,
                                                }}
                                                color="primary"
                                            />
                                        }
                                        label={toggleTheme ? "on" : "off"}
                                    />
                                </ListItem>
                            </SubList>
                            <SubList text="Language" icon={LanguageOutlined} color="grey">
                                <ListItem text="English" />
                                <ListItem text="العربية" />
                            </SubList>
                            <ListItem text="Settings" icon={Settings} color="grey" />
                            <ListItem text="Your data in YouTube" icon={SecurityOutlined} color="grey" />
                            <ListItem text="Help" icon={HelpOutline} color="grey" />
                            <ListItem text="Send feedback" icon={FeedbackOutlined} color="grey" />
                            <ListItem text="Keyboard shortcut" icon={Keyboard} color="grey" />
                            <Divider className={classes.divider} />
                            <SubList text="location: United Arab Emirates" textColor="grey">
                                <ListItem text="United Arab Emirates" textColor="grey" />
                                <ListItem text="Egypt" textColor="grey" />
                                <ListItem text="Saudi Arabia" textColor="grey" />
                            </SubList>
                            <SubList text="restricted Mode: off" textColor="grey">
                                <ListItem text="on/off" >
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={toggleTheme}
                                                onChange={() => { setToggleTheme(prev => !prev) }}
                                                value="checkedB"
                                                classes={{
                                                    thumb: classes.switch,
                                                    checked: classes.switchCheck,
                                                }}
                                                color="primary"
                                            />
                                        }
                                        label={toggleTheme ? "on" : "off"}
                                    />
                                </ListItem>
                            </SubList>
                        </List>
                    </div> : null
                }
            </div>
            <div className={classes.wrapContent} >
                <Button variant="outlined" size="medium" className={classes.SignInButton}>
                    <AccountCircle />
                    <span className={classes.SignInText}>Sign In</span>
                </Button>
            </div>
        </div>
    );
}

export default LeadingControl;